import { DropdownStaticComponent } from './dropdownStatic';
import { DropdownOptionsStaticComponent } from './dropdownOptionsStatic';

export { DropdownStaticComponent, DropdownOptionsStaticComponent };
